// Base redirect URI (domain only, no path prefix)
export const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI ?? 'http://localhost:3000';
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID ?? '85a97398-9523-46c4-8188-54a255afd0f1';
export const FEATURE_FLAG = Number(import.meta.env.VITE_FEATURE_FLAG ?? '19968');
export const URL_PREFIX = import.meta.env.VITE_URL_PREFIX ?? '/wt';

// Full app base URL combining REDIRECT_URI + URL_PREFIX
// Use this for all in-app redirects and MSAL
let baseUri = REDIRECT_URI;
while (baseUri.endsWith('/')) {
  baseUri = baseUri.slice(0, -1);
}
export const APP_BASE_URL = `${baseUri}${URL_PREFIX}`;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'https://watchtower-develop.ab-inbev.com';

// US redirect URL - where users are redirected when selecting US country
export const US_REDIRECT_URL: string =
  (import.meta.env.VITE_US_REDIRECT_URL as string) ?? 'https://watchtower-develop.ab-inbev.com/';

export const DEFAULT_API_URL = API_BASE_URL + (import.meta.env.VITE_API_BR ?? '/br/api/');
export const API_URL_CO = API_BASE_URL + (import.meta.env.VITE_API_CO ?? '/co/api/');

export const getApiUrl = (countryCode: string) => `${API_BASE_URL}/${countryCode}/api/`.toLowerCase();

export const AUTH_TOKEN_KEY = 'Auth_token';
export const ACCESS_TOKEN_KEY = 'Access_token';
